import { render, staticRenderFns } from "./table_sort_dropdown.vue?vue&type=template&id=52a26ebc&scoped=true&"
import script from "./table_sort_dropdown.vue?vue&type=script&lang=js&"
export * from "./table_sort_dropdown.vue?vue&type=script&lang=js&"
import style0 from "./table_sort_dropdown.vue?vue&type=style&index=0&id=52a26ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a26ebc",
  null
  
)

export default component.exports